// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kI_YYG_ZJsGHCCgh8E69{flex-direction:column;flex-grow:1;margin-right:-6px;display:flex;position:relative}.h5P4QkYH2NA6RGvQTii8{align-items:center;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `kI_YYG_ZJsGHCCgh8E69`,
	"headerName": `h5P4QkYH2NA6RGvQTii8`
};
export default ___CSS_LOADER_EXPORT___;
